const cookie = {
  setCookie: (name, value, domain, expire) => {
    // domain=.youbaolian.top;写入cookie到主域 子域名都可用    path=/表示本站全部路径都可使用
    let cookie = `${name}=${escape(value)}`
    if (expire) {
      let date = new Date()
      date.setSeconds(date.getSeconds() + expire)
      cookie = `${cookie};expires=${date.toGMTString()}`
    }
    if (domain) {
      cookie = `${cookie};domain=${domain};path=/`
    }
    document.cookie = `${cookie}`
  },
  getCookie: (name) => {
    if (document.cookie.length > 0) {
      let start = document.cookie.indexOf(name + '=')
      if (start !== -1) {
        start = start + name.length + 1
        let end = document.cookie.indexOf(';', start)
        if (end === -1) end = document.cookie.length
        return unescape(document.cookie.substring(start, end))
      }
    }
    return ''
  }
}
export default cookie



// WEBPACK FOOTER //
// ./src/utils/cookie.js